document.addEventListener(
  "click",
  (event) => {
    if (!window.Shopify || !window.Shopify.designMode) return;

    const link = event.target.closest("a[href]");
    if (!link) return;

    const href = link.getAttribute("href") || "";
    const isLocalControl = href === "" || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:");

    if (!isLocalControl) {
      event.preventDefault();
    }
  },
  true
);

document.addEventListener("click", (event) => {
  const toggle = event.target.closest(".menu-toggle");
  if (!toggle) return;

  const navId = toggle.getAttribute("aria-controls");
  const nav = navId ? document.getElementById(navId) : null;
  const nextState = toggle.getAttribute("aria-expanded") !== "true";

  toggle.setAttribute("aria-expanded", String(nextState));
  if (nav) {
    nav.classList.toggle("is-open", nextState);
  }
});

document.addEventListener("click", (event) => {
  const toggle = event.target.closest(".nav-dropdown-toggle");
  if (!toggle) return;

  const item = toggle.closest(".has-dropdown");
  if (!item) return;

  const nextState = !item.classList.contains("is-open");
  item.classList.toggle("is-open", nextState);
  toggle.setAttribute("aria-expanded", String(nextState));

  const link = item.querySelector(".nav-link[aria-haspopup='true']");
  if (link) {
    link.setAttribute("aria-expanded", String(nextState));
  }
});

document.addEventListener("click", (event) => {
  const thumbnail = event.target.closest("[data-product-thumbnail]");
  if (!thumbnail) return;

  const gallery = thumbnail.closest(".product-detail-media");
  const mainImage = gallery?.querySelector("[data-product-media-stage] img");
  const imageSrc = thumbnail.dataset.imageSrc;

  if (!mainImage || !imageSrc) return;

  mainImage.src = imageSrc;
  mainImage.srcset = thumbnail.dataset.imageSrcset?.trim() || "";
  mainImage.alt = thumbnail.dataset.imageAlt || "";

  gallery.querySelectorAll("[data-product-thumbnail]").forEach((item) => {
    const isActive = item === thumbnail;
    item.classList.toggle("is-active", isActive);
    item.setAttribute("aria-current", String(isActive));
  });
});

document.querySelectorAll("[data-product-description-template]").forEach((template) => {
  const target = template.parentElement?.querySelector("[data-product-description]");
  if (!target) return;

  const content = template.content.cloneNode(true);

  content.querySelectorAll("script, noscript").forEach((element) => element.remove());

  content.querySelectorAll("*").forEach((element) => {
    [...element.attributes].forEach((attribute) => {
      if (attribute.name.toLowerCase().startsWith("on")) {
        element.removeAttribute(attribute.name);
      }
    });

    element.classList.remove("loading");
  });

  content.querySelectorAll("img").forEach((image, index) => {
    const source = image.getAttribute("src") || image.getAttribute("data-src");
    if (source) image.setAttribute("src", source);

    image.removeAttribute("data-src");
    image.setAttribute("decoding", "async");
    image.setAttribute("loading", index < 2 ? "eager" : "lazy");
    image.setAttribute("referrerpolicy", "no-referrer");

    image.addEventListener(
      "error",
      () => {
        image.hidden = true;
        const fallback = document.createElement("p");
        fallback.className = "product-description-image-fallback";
        fallback.textContent = image.alt || "Product detail image";
        image.after(fallback);
      },
      { once: true }
    );
  });

  content.querySelectorAll("a[href]").forEach((link) => {
    const href = link.getAttribute("href") || "";

    if (href.startsWith("/dp/")) {
      link.setAttribute("href", `https://www.amazon.com${href}`);
    }

    if (link.href.startsWith("https://www.amazon.")) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "nofollow noopener noreferrer");
    }
  });

  target.replaceChildren(content);
});
